module.exports = __webpack_public_path__ + "img/home.32c97ccb.svg";